var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSatellite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0914 5L17.4038 9.32L15.7886 10.9352L14.1733 9.32L13.0914 10.4019L14.8667 12.1695L13.9829 13.061L14.3257 13.4114C15.0343 13.0838 15.9029 13.2057 16.4819 13.7924L13.7924 16.4819C13.2057 15.9029 13.0838 15.0343 13.4114 14.3257L13.061 13.9829L12.1695 14.8667L10.4019 13.0914L9.32 14.1733L10.9352 15.7886L9.32 17.4038L5 13.0914L6.63048 11.4762L8.24571 13.0914L9.32 12.0171L7.16381 9.86095C6.56952 9.26667 6.56952 8.29905 7.16381 7.70476L7.70476 7.16381C8.29905 6.56952 9.26667 6.56952 9.86095 7.16381L12.0171 9.32L13.0914 8.24571L11.4762 6.63048L13.0914 5ZM17.9524 14.9048C17.9524 15.713 17.6313 16.4882 17.0598 17.0598C16.4882 17.6313 15.713 17.9524 14.9048 17.9524V16.4286C15.3089 16.4286 15.6965 16.268 15.9823 15.9823C16.268 15.6965 16.4286 15.3089 16.4286 14.9048H17.9524ZM21 14.9048C21 16.5213 20.3578 18.0717 19.2147 19.2147C18.0717 20.3578 16.5213 21 14.9048 21V19.4762C16.1172 19.4762 17.2799 18.9946 18.1373 18.1373C18.9946 17.2799 19.4762 16.1172 19.4762 14.9048H21Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatellite);
export default __webpack_public_path__ + "static/media/satellite.922ff0cac59e10f638c0386061911a76.svg";
export { ForwardRef as ReactComponent };